import React from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import PauloPfp from '../../../assets/icons/PauloPfp.svg';

const styles = {
  container: {
    backgroundColor: '#17296B',
    borderRadius: '10px',
    width: '98.8%',
    minHeight: '570px',
    height: '50vh',
    padding: '15px',
    overflow: 'auto',
  },
  avatar: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginRight: '-2.5rem',
    justifyContent: 'center',
    marginLeft: '-0.5rem',
  },
  table: {
    backgroundColor: '#17296B',
    borderRadius: '10px',
    overflow: 'hidden',
    minWidth: '600px',
  },
  header: {
    fontWeight: 'bold',
    textAlign: 'left',
    padding: '10px',
    backgroundColor: '#17296B',
    color: 'white',
    borderBottom: '1px solid #2a3d7e',
  },
  row: {
    textAlign: 'left',
    verticalAlign: 'middle',
    padding: '10px',
    backgroundColor: '#17296B',
    color: 'white',
    borderBottom: '1px solid #2a3d7e',
  },
  pendingButton: {
    backgroundColor: '#4CAF50',
    border: 'none',
    color: '#fff',
    width: '70px',
    borderRadius: '5px',
    fontSize: '0.9em',
    textAlign: 'center',
  },
  reviewButton: {
    backgroundColor: '#FF5252',
    border: 'none',
    color: '#fff',
    width: '70px',
    borderRadius: '5px',
    fontSize: '0.9em',
    textAlign: 'center',
  },
  validatedButton: {
    backgroundColor: '#777',
    border: 'none',
    color: '#fff',
    width: '70px',
    borderRadius: '5px',
    fontSize: '0.9em',
    textAlign: 'center',
  },
  checkbox: {
    marginRight: '-6rem',
    transform: 'scale(1.5)',
    marginLeft: '1.5rem',
  },
  '@media (max-width: 768px)': {
    container: {
      height: 'auto',
      padding: '10px',
    },
    table: {
      minWidth: '100%',
    },
    header: {
      padding: '8px',
      fontSize: '0.9em',
    },
    row: {
      padding: '8px',
      fontSize: '0.9em',
    },
    pendingButton: {
      width: '60px',
      fontSize: '0.8em',
    },
    reviewButton: {
      width: '60px',
      fontSize: '0.8em',
    },
    validatedButton: {
      width: '60px',
      fontSize: '0.8em',
    },
    checkbox: {
      transform: 'scale(1.2)',
      marginLeft: '3px',
    },
  },
};

const ManageLeaves = () => (
  <div style={styles.container}>
    <div style={{overflowX: 'auto'}}>
      <Table hover responsive style={styles.table}>
      <thead>
        <tr>
          <th style={styles.header}></th>
          <th style={styles.header}></th>
          <th style={styles.header}>Funcionários</th>
          <th style={styles.header}>Horas Planeadas</th>
          <th style={styles.header}>Horas Trabalhadas</th>
          <th style={styles.header}>Saldo de Horas</th>
          <th style={styles.header}>Status</th>
          <th style={styles.header}>Ação</th>
        </tr>
      </thead>
      <tbody >
        <tr>
          <td style={styles.row}>
            <Form.Check type="checkbox" style={styles.checkbox} />
          </td>
          <td style={styles.row}>
            <img 
              src={PauloPfp} 
              alt="Avatar" 
              style={styles.avatar}
            />
          </td>
          <td style={styles.row}>Paulo Bettencourt</td>
          <td style={styles.row}>160h</td>
          <td style={styles.row}>162h32m</td>
          <td style={styles.row}>+2h32m</td>
          <td style={styles.row}>Pendente</td>
          <td style={styles.row}>
            <Button style={styles.pendingButton}>Validar</Button>
          </td>
        </tr>
        <tr>
          <td style={styles.row}>
            <Form.Check type="checkbox" style={styles.checkbox} />
          </td>
          <td style={styles.row}>
            <img 
              src={PauloPfp}
              alt="Avatar" 
              style={styles.avatar}
            />
          </td>
          <td style={styles.row}>Simão Ferreira</td>
          <td style={styles.row}>170h</td>
          <td style={styles.row}>162h32m</td>
          <td style={styles.row}>-7h28m</td>
          <td style={styles.row}>Erro</td>
          <td style={styles.row}>
            <Button style={styles.reviewButton}>Rever</Button>
          </td>
        </tr>
        <tr>
          <td style={styles.row}>
            <Form.Check type="checkbox" style={styles.checkbox} />
          </td>
          <td style={styles.row}>
            <img 
              src={PauloPfp} 
              alt="Avatar" 
              style={styles.avatar}
            />
          </td>
          <td style={styles.row}>Tomás Simas</td>
          <td style={styles.row}>200h</td>
          <td style={styles.row}>200h</td>
          <td style={styles.row}>0h</td>
          <td style={styles.row}>Validado</td>
          <td style={styles.row}>
            <Button style={styles.validatedButton}>Validado</Button>
          </td>
        </tr>
        <tr>
          <td style={styles.row}>
            <Form.Check type="checkbox" style={styles.checkbox} />
          </td>
          <td style={styles.row}>
            <img 
              src={PauloPfp}
              alt="Avatar" 
              style={styles.avatar}
            />
          </td>
          <td style={styles.row}>Rodrigo Mendes</td>
          <td style={styles.row}>160h</td>
          <td style={styles.row}>162h32m</td>
          <td style={styles.row}>+2h32m</td>
          <td style={styles.row}>Pendente</td>
          <td style={styles.row}>
            <Button style={styles.pendingButton}>Validar</Button>
          </td>
        </tr>
      </tbody>
      </Table>
    </div>
  </div>
);

export default ManageLeaves;
